import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, fmtDate, fmtQty } from "../../api";
import { Plus } from "lucide-react";
import StatusBadge from "../../components/StatusBadge";
import MfgTabs from "../../components/MfgTabs";

const STATUSES = ["", "Draft", "Ready", "In Progress", "Completed", "Cancelled"];

function actualHours(m) {
  if (!m.started_at || !m.completed_at) return "-";
  const h = (new Date(m.completed_at) - new Date(m.started_at)) / 3600000;
  return `${h.toFixed(1)} h`;
}

export default function MOs() {
  const [mos, setMos] = useState(null);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/mos", { params: { status, search } }).then((r) => setMos(r.data)).catch(() => {});
  }, [status, search]);

  return (
    <div data-testid="mos-page" className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-heading text-3xl font-extrabold text-[#002B5D] tracking-tight">Manufacturing</h1>
        <Link to="/manufacturing/orders/new" data-testid="new-mo-button"
          className="inline-flex items-center gap-2 h-10 px-4 rounded-md font-heading font-bold text-sm text-white" style={{ backgroundColor: "#002B5D" }}>
          <Plus className="w-4 h-4" /> New Manufacturing Order
        </Link>
      </div>
      <MfgTabs />
      <div className="flex flex-wrap gap-3">
        <input data-testid="mo-search-input" placeholder="Search MO number..." value={search} onChange={(e) => setSearch(e.target.value)} className="sk-input max-w-xs" />
        <div className="flex gap-1 flex-wrap">
          {STATUSES.map((s) => (
            <button key={s || "all"} data-testid={`mo-filter-${s ? s.toLowerCase().replace(/\s/g, "-") : "all"}`} onClick={() => setStatus(s)}
              className={`px-3 h-10 rounded-md text-xs font-semibold border transition-colors ${status === s ? "bg-[#002B5D] text-white border-[#002B5D]" : "bg-white text-slate-600 border-border hover:border-slate-400"}`}>
              {s || "All"}
            </button>
          ))}
        </div>
      </div>
      <div className="sk-card overflow-x-auto">
        <table className="w-full sk-table" data-testid="mo-table">
          <thead>
            <tr><th>MO Number</th><th>Product</th><th className="text-right">Planned</th><th className="text-right">Produced</th><th>Lot</th><th>Status</th><th>Created</th><th className="text-right">Est. Time</th><th className="text-right">Actual Time</th></tr>
          </thead>
          <tbody>
            {!mos && <tr><td colSpan={9} className="text-center text-slate-400">Loading...</td></tr>}
            {mos?.length === 0 && <tr><td colSpan={9} className="text-center text-slate-400">No manufacturing orders</td></tr>}
            {mos?.map((m) => (
              <tr key={m.id} className="cursor-pointer" onClick={() => navigate(`/manufacturing/orders/${m.id}`)} data-testid={`mo-row-${m.mo_number}`}>
                <td className="font-mono font-semibold text-[#002B5D]">{m.mo_number}</td>
                <td>{m.product_name}</td>
                <td className="text-right font-mono">{fmtQty(m.planned_qty)} {m.uom}</td>
                <td className="text-right font-mono">{fmtQty(m.produced_qty)}</td>
                <td className="font-mono text-xs">{m.lot_number || "-"}</td>
                <td><StatusBadge status={m.status} testid={`mo-status-${m.mo_number}`} /></td>
                <td className="text-slate-500">{fmtDate(m.created_at)}</td>
                <td className="text-right font-mono text-slate-500">{m.estimated_hours != null ? `${m.estimated_hours} h` : "-"}</td>
                <td className="text-right font-mono text-slate-500">{actualHours(m)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
